




















import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { Routes } from '@/router/routes'
import PriceConfig from '@/dto/price_config/PriceConfig'
import priceConfigStore from '@/stores/PriceConfigStore'

@Component
export default class PriceConfigDeleteForm extends Vue {
  @Prop(Object)
  model: PriceConfig

  priceConfigStore = priceConfigStore

  async removePriceConfig() {
    const priceConfigId = parseInt(this.$route.params.priceConfigId)

    if (priceConfigId === this.priceConfigStore.priceConfigId) {
      await this.$router.push({ name: Routes.priceConfigs })
    }

    await this.priceConfigStore.deletePriceConfig(this.model.id as number)
  }
}
